import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const About3rdX = () => (
  <Layout>
    <div className='about3rd'>
      <h1 className='3rdTitle'>Privacy Policy</h1>

      <p>Last Updated: April 10, 2025</p>

      <h2>Introduction</h2>
      <p>
        Welcome to Haza Platform (hereinafter referred to as 'Haza'). Haza is provided and controlled by Taala PTE LTD. We respect and protect the personal information and privacy of all Haza users in accordance with the applicable privacy laws worldwide.
      </p>

      <h2>List of Third-Party SDKs</h2>
      <p>
        Latest Effective Date: April 10, 2025
      </p>
      <p>
        In the course of providing services to users, Haza integrates the following third-party SDK technologies. When accessing third-party webpages or using applications developed by third parties, these entities may employ their own cookies or other technical methods. Such technologies are beyond our control and are not governed by this policy. For optimal information security, we recommend that you review the privacy terms of any third-party SDK before utilizing their services. To safeguard your legitimate rights and interests, if you identify any risks associated with these SDKs or similar applications, we advise you to cease related operations and contact us promptly.
      </p>
      <p>
        To enhance service offerings, optimize stability, improve quality, or upgrade functionalities, we may modify the third-party SDKs we integrate and update the SDK directory accordingly. In compliance with applicable laws, regulations, and regulatory requirements, we evaluate the legality, legitimacy, and necessity of third-party SDKs that collect your personal information prior to integration to ensure the protection of your data. You can access each third party's data usage and protection rules through the relevant links. Note that third-party SDKs may update their data processing practices due to version upgrades, policy changes, or other adjustments. Please refer to their official documentation for details.
      </p>

      <h3>SDK Name: “Shengwang” SDK</h3>
      <p><strong>Service Provider:</strong> Shanghai Zhaoyan Network Technology Co., Ltd., a subsidiary of Agora Inc.</p>
      <p><strong>Purpose of Use:</strong> To enable audio and video functionalities.</p>
      <p><strong>Usage Scenario:</strong> Utilized when users engage in audio and video features such as sending voice or video messages.</p>
      <p><strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: Device type, model, CPU information, battery status, operating system details.</li>
        <li>Network Information: IP address, network type.</li>
        <li>Identifiers: Device identifiers, MAC address, WLAN access points, sender/receiver user IDs.</li>
        <li>User Data: User attributes, channel information, usage duration, in-channel settings, logs, and content transmitted (text, audio, or other media).</li>
      </ul>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> The SDK is governed by the privacy policy of Agora Inc., which also applies to its subsidiaries including Shanghai Zhaoyan Network Technology Co., Ltd. <a href="https://www.agora.io/en/privacy-policy/" target="_blank" rel="noreferrer">https://www.agora.io/en/privacy-policy/</a></p>

      <h3>SDK Name: Google SDK</h3>
      <p><strong>Service Provider:</strong> Google Inc.</p>
      <p><strong>Purpose of Use:</strong> To enable Google Pay and third-party login functionality.</p>
      <p><strong>Usage Scenario:</strong> Utilized as a login method on the login page.</p>
      <p><strong>Types of Personal Information Collected:</strong> None</p>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a></p>

      <h3>SDK Name: Firebase SDK</h3>
      <p><strong>Service Provider:</strong> Google Inc.</p>
      <p><strong>Purpose of Use:</strong> To collect crash reports for stability monitoring.</p>
      <p><strong>Usage Scenario:</strong> Utilized when the application experiences unexpected crashes.</p>
      <p><strong>Types of Personal Information Collected:</strong> None</p>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a></p>

      <h3>SDK Name: Facebook SDK</h3>
      <p><strong>Service Provider:</strong> Meta Platforms, Inc.</p>
      <p><strong>Purpose of Use:</strong> To enable Facebook login functionality.</p>
      <p><strong>Usage Scenario:</strong> Utilized as a third-party login method on the login page.</p>
      <p><strong>Types of Personal Information Collected:</strong> None</p>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0" target="_blank" rel="noreferrer">https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0</a></p>

      <h3>SDK Name: “Tencent Cloud IM” SDK</h3>
      <p><strong>Service Provider:</strong> Tencent Cloud International Pte. Ltd.</p>
      <p><strong>Purpose of Use:</strong> To enable instant messaging functionalities.</p>
      <p><strong>Usage Scenario:</strong> Utilized when users send text messages, images, or other types of messages.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: Device type, model, CPU information, battery status, operating system details.</li>
        <li>Network Information: IP address, network type.</li>
        <li>Identifiers: Device identifiers, WLAN access points, sender/receiver user IDs.</li>
        <li>User Data: User attributes, usage duration, logs, and content transmitted (text, images, etc.).</li>
      </ul>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://www.tencentcloud.com/?lang=en&pg=" target="_blank" rel="noreferrer">https://www.tencentcloud.com/?lang=en&pg=</a></p>

      <h3>SDK Name: “Tencent Cloud RTC” SDK</h3>
      <p><strong>Service Provider:</strong> Tencent Cloud International Pte. Ltd.</p>
      <p><strong>Purpose of Use:</strong> To enable real-time audio and video communication features.</p>
      <p><strong>Usage Scenario:</strong> Utilized during actions such as entering a room, going on mic, or playing music.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: Device type, model, CPU information, battery status, operating system details.</li>
        <li>Network Information: IP address, network type.</li>
        <li>Identifiers: Device identifiers, WLAN access points, sender/receiver user IDs.</li>
        <li>User Data: User attributes, usage duration, logs, and content transmitted (text, images, etc.).</li>
      </ul>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://www.tencentcloud.com/?lang=en&pg=" target="_blank" rel="noreferrer">https://www.tencentcloud.com/?lang=en&pg=</a></p>

      <h3>SDK Name: Adjust SDK</h3>
      <p><strong>Service Provider:</strong> Adjust GmbH</p>
      <p><strong>Purpose of Use:</strong> For data tracking and analytics purposes.</p>
      <p><strong>Usage Scenario:</strong> Utilized during user registration and related functional activities.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: Device type, model, CPU information, battery status, operating system details.</li>
        <li>Network Information: IP address, network type.</li>
        <li>Identifiers: Device identifiers, WLAN access points, sender/receiver user IDs.</li>
        <li>User Data: User attributes, usage duration, logs.</li>
      </ul>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://www.adjust.com/terms/privacy-policy/" target="_blank" rel="noreferrer">https://www.adjust.com/terms/privacy-policy/</a></p>

      <h3>SDK Name: “Shumei” SDK</h3>
      <p><strong>Service Provider:</strong> DEEPCLEER TECHNOLOGY PTE. LTD</p>
      <p><strong>Purpose of Use:</strong> Data statistics and Anti-cheating.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: equipment brand, equipment manufacturer, equipment model number, equipment name, equipment system type and version, equipment basic configuration, equipment basic settings, equipment environment.</li>
        <li>Network Information: network access form, wireless router identification (BSSID, SSID) and IP address, WIFI list, network operator information, network base station information, network connection status.</li>
        <li>Identifiers: Android ID, IDFV (Identifier For Vendor), IDFA (Identity for Advertisers), OAID (Open Anonymous Device Identifier).</li>
        <li>User Data: SDK host application package name and version number.</li>
      </ul>
      <p><strong>Client Platform:</strong> Android</p>
      <p><strong>Privacy Policy Link:</strong> <a href="https://deepcleer.com/account/serviceItems#TRANSFER-OF-PERSONAL-INFORMATION" target="_blank" rel="noreferrer">https://deepcleer.com/account/serviceItems#TRANSFER-OF-PERSONAL-INFORMATION</a></p>
    </div>
  </Layout>
)

export default About3rdX
